import { TextField, TextFieldProps } from "@mui/material";
import { useField } from "formik";
import { useCallback } from "react";

export type FormikTextProps = TextFieldProps & { name: string };

export const FormikText = (props: FormikTextProps) => {
  const [field, meta, helpers] = useField<string>(props.name);

  const setTouched = useCallback(() => helpers.setTouched(true), [helpers.setTouched]);

  return (
    <TextField
      value={field.value}
      onChange={field.onChange}
      error={meta.touched && !!meta.error && meta.initialValue !== field.value}
      helperText={meta.touched && meta.error}
      onFocus={setTouched}
      {...props}
    />
  );
};
